import {
  Component,
  ChangeDetectionStrategy,
  input,
  inject,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RouterModule } from "@angular/router";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { StudentProfile } from "../../../api/models/student-profile";
import { LocaleService } from "../../../shared/services/locale.service";

@Component({
  selector: "app-student-contact-details",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, FontAwesomeModule, RouterModule],
  // display:contents so the address rows below become items of the parent
  // contact-details grid (in app-profile-shell) and align with the other rows.
  host: { class: "contents" },
  template: `
    <div class="text-mty-body/60">{{ "Address" | translate }}</div>
    <div class="text-mty-body break-words">
      {{ entity().homeAddress.street }} {{ entity().homeAddress.number
      }}{{
        entity().homeAddress.numberSuffix
          ? "-" + entity().homeAddress.numberSuffix
          : ""
      }}<br />
      {{ entity().homeAddress.postalCode }}, {{ entity().homeAddress.city
      }}<br />
      {{ locale.getCountryName(entity().homeAddress.country) }}
    </div>
    <a
      routerLink="/student/settings"
      class="col-span-2 justify-self-end text-mty-primary hover:text-mty-body transition-colors"
      [attr.aria-label]="'Edit' | translate"
    >
      <fa-icon [icon]="faEdit"></fa-icon>
    </a>
  `,
})
export class StudentContactDetailsComponent {
  readonly locale = inject(LocaleService);

  entity = input.required<StudentProfile>();
  faEdit = faEdit;
}
